import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import JupasSelectButton from '../blocks/JupasSelectButton';
import { JUPAS_BAND_COLORS } from '../../utils/jupasOrderDisplay';
import JupasProgrammeCard from './JupasProgrammeCard';

const JupasProgrammesSection = ({
    jupasProgrammes,
    programmeClassifications,
    isLoadingClassifications,
    standAlone = true
}) => {
    const { t } = useTranslation();
    const [expandedCodes, setExpandedCodes] = useState({});

    useEffect(() => {
        const firstCode = jupasProgrammes[0]?.code;
        if (!firstCode) return;
        setExpandedCodes((prev) => (firstCode in prev ? prev : { ...prev, [firstCode]: true }));
    }, [jupasProgrammes[0]?.code]);

    const toggleExpanded = (programme) => {
        setExpandedCodes((prev) => ({ ...prev, [programme.code]: !prev[programme.code] }));
    };

    return (
        <div className={`${standAlone ? 'bg-surface border border-edge rounded-lg shadow-sm p-6 mt-6' : 'pt-2'} mb-6`}>
            {jupasProgrammes.length > 0 && (
                <div className="mt-2 mb-2">
                    <h3 className={`${standAlone ? 'text-xl font-bold text-ink mb-6' : 'text-lg font-medium text-ink mb-3'}`}>
                        {t('userDashboard.topJupasProgrammes')}
                    </h3>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-stretch">
                        {jupasProgrammes[0] && (
                            <div className="lg:col-span-2 h-full">
                                <JupasProgrammeCard
                                    programme={jupasProgrammes[0]}
                                    rank={1}
                                    bandLabel={t('jupa.bandA')}
                                    bandColor={JUPAS_BAND_COLORS.A}
                                    classificationData={programmeClassifications[jupasProgrammes[0].code]}
                                    isExpanded={!!expandedCodes[jupasProgrammes[0].code]}
                                    onToggle={toggleExpanded}
                                />
                            </div>
                        )}

                        <div className="lg:col-span-1 space-y-4">
                            {jupasProgrammes[1] && (
                                <JupasProgrammeCard
                                    programme={jupasProgrammes[1]}
                                    rank={2}
                                    bandLabel={t('jupa.bandA')}
                                    bandColor={JUPAS_BAND_COLORS.A}
                                    classificationData={programmeClassifications[jupasProgrammes[1].code]}
                                    isExpanded={!!expandedCodes[jupasProgrammes[1].code]}
                                    onToggle={toggleExpanded}
                                />
                            )}

                            <JupasSelectButton />
                        </div>
                    </div>
                    {isLoadingClassifications ? (
                        <p className="mt-3 text-xs text-ink-subtle">{t('common.loading')}</p>
                    ) : null}
                </div>
            )}

            {jupasProgrammes.length === 0 && (
                <div className="text-center py-8">
                    <div className="text-ink-subtle mb-4">
                        <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-medium text-ink-subtle mb-2">{t('userDashboard.noSummaryData')}</h3>
                    <p className="text-sm text-ink-subtle">{t('userDashboard.noSummaryDataDesc')}</p>
                </div>
            )}
        </div>
    );
};

export default JupasProgrammesSection;
